<template>
  <div class="content-wrapper">
    <el-row :gutter="20">
      <el-col :span="4">
        <help-menu />
      </el-col>
      <el-col :span="20">
        <div class="help-content">
          <h2 class="help-title">配送范围时间</h2>
          <div class="logistics-table">
            <el-table :data="infoData" border style="width: 80%" >
              <el-table-column prop="info" label="服务内容" />
              <el-table-column prop="time" label="时间、时限" width="150"/>
              <!-- <el-table-column prop="fee" label="运费" width="150"/> -->
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HelpMenu from './components/help-menu'
export default {
  name: 'HelpLogistics',
  components: {
    HelpMenu
  },
  data() {
    return {
      infoData: [
        {
          info: '国内指定地级及以上城市物流运输（新、藏、蒙顺延3-5天）',
          time: '时效为2~7天',
          fee: '免运费'
        },
        {
          info: '国内指定地级及以上城市快递运输（新、藏、蒙顺延3-5天）',
          time: '时效为1~5天',
          fee: '免运费'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.logistics-table {
  margin: 10px 0 0 35px;
  /deep/ .el-table th {
    background: #FF8B3E;
    text-align: center;
    font-size: 20px;
    color: #484848;
  }
  /deep/ .el-table td {
    font-size: 16px;
    text-align: center;
  }
}
</style>
